<template>
    <section class="auth open" @click="qr_ios = false, qr_gplay = false">
        <div class="auth-welcome" :style="{backgroundImage: 'url('+ left_bg +')'}">
            <div class="logo">
                <!-- <img class="logo__icon" src="@/assets/images/logo.png" width="40px" alt=""> -->
                <p class="logo__name">WildWood</p>
            </div>
            <div class="auth-welcome__text" :style="{color: '#181715'}"><span>Присоединяйся</span> <br><span>к тусовке WildWood</span></div>
            <!-- <img src="@/assets/images/welcome-580.png" class="auth-welcome__image"> -->
        </div>
            <div class="auth-container">
                <div class="mobile-apps" v-if="!webViewMode && !AppValidating">
                    <div class="mobile-app" @click.stop>
                        <a href="https://play.google.com/store/apps/details?id=com.wildwoodonline" target="_blank" class="mobile-app__link"></a>
                        <div class="mobile-app__open" @click="qr_gplay = true, qr_ios = false"></div>
                        <div class="mobile-app-popup" v-if="qr_gplay">
                            <div class="mobile-qr">
                                <img src="@/assets/images/welcome/qr-gplay.webp" alt="qr wildwood gplay" width="200px">
                            </div>
                            <a class="mobile-app__gplay" href="https://play.google.com/store/apps/details?id=com.wildwoodonline" target="_blank">Ссылка на приложение</a>
                        </div>
                        <img src="@/assets/images/welcome/gplay.svg" width="24px">
                        <p>GPlay</p>
                    </div>
                    <div class="mobile-app" @click.stop>
                        <a href="https://play.google.com/store/apps/details?id=com.wildwoodonline" target="_blank" class="mobile-app__link"></a>
                        <div class="mobile-app__open" @click="qr_ios = true, qr_gplay = false"></div>
                        <div class="mobile-app-popup" v-if="qr_ios">
                            <div class="mobile-qr">
                                <img src="@/assets/images/welcome/qr-ios.webp" alt="qr wildwood gplay" width="200px">
                            </div>
                            <a class="mobile-app__gplay" href="https://apps.apple.com/us/app/wildwood-%D1%81%D0%BF%D0%BE%D1%80%D1%82%D0%B8%D0%B2%D0%BD%D0%BE%D0%B5-%D1%81%D0%BE%D0%BE%D0%B1%D1%89%D0%B5%D1%81%D1%82%D0%B2%D0%BE/id1604410665" target="_blank">Ссылка на приложение</a>
                        </div>
                        <img src="@/assets/images/welcome/ios.svg" width="128px">
                    </div>
                </div>
                <div class="auth-wrap">
                    <h1 class="auth-title">Добро пожаловать в WildWood</h1>
                    <!-- <h1 class="auth-title">Присоединяйся к тусовке WildWood</h1> -->
                    <!-- <p class="auth-text">Войдите, чтобы учавствовать в событиях и постить контент. <br>Это быстро, и никакой рекламы...</p> -->
                    <p class="auth-text">Войдите, чтобы управлять функциями сервиса. <br>Это быстро, и никакой рекламы...😉</p>
                    <div class="auth-social" v-if="!AppValidating">
                        <div class="auth-social__item" :class="{wait: google_loading}" @click="loginWithGoogle()">
                            <img src="@/assets/images/auth/icon_google.svg" width="19px" v-if="!google_loading">
                            <p v-if="!google_loading">Войти через Google</p>
                            <svg v-if="google_loading" class="auth-loader" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                                <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                <animateTransform 
                                    attributeName="transform" 
                                    attributeType="XML" 
                                    type="rotate"
                                    dur="1s" 
                                    from="0 50 50"
                                    to="360 50 50" 
                                    repeatCount="indefinite" />
                                </path>
                            </svg>
                        </div>
                        <!-- <div class="auth-social__item ya" @click="loginWithYandex()">
                            <img src="@/assets/images/auth/icon_ya.svg" width="24px">
                        </div>
                        <div class="auth-social__item" @click="itLater()">
                            <img src="@/assets/images/auth/icon_apple.svg" width="20px">
                        </div> -->
                    </div>
                    <div class="auth-or" v-if="!AppValidating">
                        <div class="auth-or__line"></div>
                        <p class="auth-or__text">или</p>
                        <div class="auth-or__line"></div>
                    </div>
                    <form class="auth-form" @submit.prevent="submitHandler">
                        <input class="auth-form__input" type="email" name="email" v-model.trim="email" :class="{invalid: ($v.email.$dirty && $v.email.required) || ($v.email.$dirty && $v.email.email)}" placeholder="Введите email" required>
                        <div class="auth-string" v-show="two_step">
                            <input class="auth-form__input" type="text" name="firstname" v-model.trim="firstname" placeholder="Имя" required>
                            <input class="auth-form__input" type="text" name="lastname" v-model.trim="lastname" placeholder="Фамилия" required>
                        </div>
                        <input class="auth-form__input" v-show="two_step" type="password" name="password" v-model.trim="password" :class="{invalid: ($v.password.$dirty && $v.password.required) || ($v.password.$dirty && $v.password.minLength)}" placeholder="Пароль" required>
                        <!-- <input class="auth-form__input" type="password" name="password" v-model.trim="repeatPassword" placeholder="Приложи сетчатку носа" required> -->
                            <p class="auth-form__agree">Регистрируясь, вы автоматически соглашаетесь с <router-link :to="{name: 'policy'}">политикой конфиденциальности</router-link> и <router-link :to="{name: 'agree'}">правилами сервиса</router-link></p>
                        <div class="auth-buttons">
                            <div class="auth-form__button" @click="two_step = true" v-show="!two_step">Начать</div>
                            <input class="auth-form__button" type="submit" value="Начать" v-show="two_step">
                            <router-link to="/login" class="auth-link">Войти</router-link>
                        </div>
                    </form>
                </div>
            <div class="auth-info" v-if="!AppValidating">
            <router-link :to="{name: 'welcome'}" class="auth-what">Что такое wildwood?</router-link>
            <p class="copyright">©copyright by wildwood 2021</p>
        </div>
            </div>
    </section>
</template>

<script>
import greetings from "@/data/main/greetings"
import {email, required, minLength} from 'vuelidate/lib/validators'

export default {
    name: 'login',
    data: () => ({
        qr_ios: false,
        qr_gplay: false,
        two_step: false,
        left_bg: require('@/assets/images/auth/reg-surf-party.webp'),
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        google_loading: false,
        city: null,
        country: null,
        country_code: null,
        state_code: null,
        ip: null
    }),
    validations: {
        email: {email, required},
        password: {required, minLength: minLength(6)},
        firstname: required,
        lastname: required
    },
    computed: {
        webViewMode() {
            return this.$store.getters.webViewMode
        },
        AppValidating() {
            return this.$store.getters.AppValidating
        }
    },
    methods: {
        async submitHandler () {
            if (this.$v.$invalid){
                this.$v.$touch()    
                return
            }else{
                const formData = {
                    email: this.email,
                    password: this.password,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    browser: navigator.userAgent,
                    country: this.country,
                    state: this.state,
                    country_code: this.country_code, 
                    state_code: this.state_code,
                    ip: this.ip
                };
                await this.$store.dispatch('newUser', formData).then((res) => {
                    this.successfullReg(res)
                })
            }
        },
        saveUser() {
            let user = localStorage.getItem('user')
            try {
                user ? 
                    window.ReactNativeWebView.postMessage(JSON.stringify({method: 'saveUser', params: { user: JSON.stringify(user) }})) 
                    : ''
            } catch (error) {
                error
            }
        },
        setRnLogin() {
            window.rnLoginGoogle = async ({accessToken, idToken}) => {
                var userInfo = {
                    accessToken,
                    idToken,
                    audience: process.env.VUE_APP_GOAUTH_CLIENT,
                    browser: navigator.userAgent,
                    country: this.country,
                    state: this.state,
                    country_code: this.country_code, 
                    state_code: this.state_code,
                    ip: this.ip
                }
                
                await this.$store.dispatch('loginGoogleOAuth', userInfo)
                .then(() => {
                    this.verifyToken()
                })
            }
            window.rnLoginYandex = async ({token}) => {
                this.sendRegData(token)
            }
        },
        async loginWithGoogle () {
            this.google_loading = true
            if (this.webViewMode) {
                try {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ method: 'googleLogin' }))
                } catch(e) {
                    console.log(e);
                }
            } else {
                this.$gAuth
                    .signIn()
                    .then(async GoogleUser => {
                        this.google_loading = false
                        var userInfo = {
                            accessToken: GoogleUser.getAuthResponse().accessToken,
                            idToken: GoogleUser.getAuthResponse().id_token,
                            audience: process.env.VUE_APP_GOAUTH_CLIENT,
                            browser: navigator.userAgent,
                            country: this.country,
                            state: this.state,
                            country_code: this.country_code, 
                            state_code: this.state_code,
                            ip: this.ip
                        }
                        await this.$store.dispatch('loginGoogleOAuth', userInfo).then(() => {
                            this.verifyToken()
                        })
                    })
                    .catch(() => {
                        this.google_loading = false
                    })
            }
        },
        loginWithYandex() {
            if (this.webViewMode) {
                try {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ method: 'yandexLogin' }))
                } catch(e) {
                    console.log(e);
                }
            } else {
                    
                window.YaAuthSuggest.init(
                    {
                        client_id: '8de34fc2da174651974b187d0e984d98',
                        response_type: 'token',
                        redirect_uri: 'https://wiildwood.online/auth/yandex'
                    },
                    'https://wiildwood.online'
                )
                .then(data => {
                    data.handler()
                })
                .catch(error => this.$store.dispatch('addError', {message: error}));
            }
        },
        async verifyToken () {
            let user = localStorage.getItem('user')
            try {
                user ? window.ReactNativeWebView.postMessage(JSON.stringify(user)) : ''
            } catch (error) {
                error
            }
            this.$router.push('/events')
            this.$store.dispatch('setModal', greetings )
        },
        async successfullReg (res) {
            res.user ? (this.$router.push('/login'), this.$store.dispatch('addNotification', {message: `Мы отправили письмо активации на ${res.user.email}. Пожалуйста, подтвердите email, для входа в сервис. Проверьте спам ⚠`})) : alert('Какая то ошибка')
        },
        itLater() {
            this.$store.dispatch('addNotification', {message: 'Этот способ регистрации, будет добавлен позднее.'})
        },
        getAreaInfo() {
            let referrer = document.referrer;
            this.$axios.get('https://ipinfo.io?token=03c7795c46fbad').then(resp => {
                this.ip = resp.data.ip
                this.lc = resp.data.loc
                let data = resp.data ? {
                    ip: resp.data.ip, 
                    country: resp.data.country, 
                    city: resp.data.city,
                    page: this.$route.name,
                    referrer
                } : '';
                this.$axios.post('/api/guest', data)
                if (this.lc && this.lc.indexOf(',') !== -1) {
                    this.getState()
                }            
            })
        },
        async getState() {
            let pos = this.lc.split(',');
            await this.$axios.post('/api/zones/by_coords', {coords: {longitude: Number(pos[1]), latitude: Number(pos[0])}})
            .then( res => {
                this.country = res.data.country,
                this.state = res.data.state,
                this.country_code = res.data.country_code, 
                this.state_code = res.data.state_code
            })
        },
        eventYaLogin() {
            window.addEventListener("message", (event) =>
            {
                if (event.origin == "https://wiildwood.online" 
                    && event.data 
                    && event.data.type === 'token'
                    && event.data.payload
                    && event.data.payload.access_token) {
                        this.sendRegData(event.data.payload.access_token)
                }
            }, false);
        },
        async sendRegData(token) {
            if (token) {
                let data = {
                    token,
                    browser: navigator.userAgent,
                    country: this.country,
                    state: this.state,
                    country_code: this.country_code,
                    state_code: this.state_code,
                    ip: this.ip
                };

                await this.$store.dispatch('loginYandex', data)
                    .then(() => {
                        this.verifyToken()
                    })
            } else {
                this.$store.dispatch('addError', {message: 'Не удалось получить данные пользователя Яндекс'})
            }
        },
    },
    created() {
        this.getAreaInfo()
        this.setRnLogin()
        this.eventYaLogin()
        document.title = this.$route.meta.title;
    }
}
</script>